import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC, useEffect, useMemo } from 'react';
import { BreakpointsInPx } from '../../../constants/breakpoints.constants';
import useEEActive from '../../../hooks/useEEActive';
import useMediaQuery from '../../../lib/custom-hooks/useMediaQuery';
import { SocialMediaBarModel } from './models/socialMediaBar.model';
import { TSocialMediaBarProps } from './types/socialMediaBar.types';
import SocialLinks from './components/socialLinks';
import { windowService } from '../../../utils/window.utils';
import { addToAnyScript } from '../../../utils/addToAnyScript.utils';
import SocialMediaDropdown from './components/socialMediaDropdown';

const SocialMediaBar: FC<TSocialMediaBarProps & { extraClassName?: string }> = (props) => {
  const model = new SocialMediaBarModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);
  const isEEactive = useEEActive();
  const { listType = 'bar', shareURL } = props;

  useEffect(() => {
    const a2a_config = windowService().a2a_config || {};
    a2a_config.templates = a2a_config.templates || {};

    function my_addtoany_onshare(data) {
      return {
        title: data.node.getAttribute('data-title') || '',
        url: data.node.getAttribute('data-is-page-url') ? windowService().location.href : '',
      };
    }

    a2a_config.callbacks = [];
    a2a_config.callbacks.push({
      share: my_addtoany_onshare,
    });

    windowService().a2a_config = a2a_config;
  }, []);

  useEffect(() => {
    setTimeout(() => {
      addToAnyScript();
    });
  }, []);

  const countValidSocialLinks = useMemo(() => {
    return (
      model.socialLinksItems?.filter(
        (item) => !!(isEEactive || (item?.fields?.icon?.fields?.iconKey?.value && item?.fields?.icon?.fields?.iconUrl?.value))
      ).length || 0
    );
  }, [model.socialLinksItems]);

  if ((!isDesktop && !props.showInMobile) || countValidSocialLinks === 0) return null;

  if (listType === 'dropdown') {
    return (
      <SocialMediaDropdown
        isEEactive={isEEactive}
        socialLinksItems={model.socialLinksItems}
        useAnalytics={props.useAnalytics}
        socialText={model?.socialText}
        shareURL={shareURL}
      />
    )
  }

  return (
    <div className={`social-media-bar ${props.extraClassName || ''}`}>
      <div className="social-media-bar__social">
        {model?.socialText && <Text tag="div" className="social-media-bar__social-text" field={model?.socialText} />}
        <div className="social-media-bar__social-icons a2a_kit a2a_kit_size_32 a2a_default_style">
          <SocialLinks isEEactive={isEEactive} socialLinksItems={model.socialLinksItems} useAnalytics={props.useAnalytics} />
        </div>
      </div>
    </div>
  );
};

export default SocialMediaBar;
